import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Cadeau / parrainage / bonus — paquet cadeau duotone */
export const GiftIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Corps menthe */}
      <rect x="3.5" y="11" width="17" height="10" rx="1.5" fill="var(--equiply-icon-bg)" fillOpacity="0.6" />
      {/* Boîte */}
      <rect x="3.5" y="11" width="17" height="10" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Couvercle */}
      <rect x="2.5" y="7" width="19" height="4" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Ruban vertical */}
      <path d="M12 7v14" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" />
      {/* Nœud */}
      <path
        d="M12 7c-1-1.5-3-3-4-2s.5 3 2 3M12 7c1-1.5 3-3 4-2s-.5 3-2 3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
GiftIcon.displayName = "GiftIcon";
